/**
 * Modal Support
 */
(function () {
    // Vanilla js for modals
    let openEls = document.querySelectorAll("[data-open]");
    let closeEls = document.querySelectorAll("[data-close]");
    let returnToStoriesButtons = document.querySelectorAll(".js-return-to-stories, .video-story");
    let transcriptTexts = document.querySelectorAll('.js-collapse');
    let isVisible = "is-visible";


    /**
     * function loadModalContent(ele, nid, fallbackUrl) {
        let request = new XMLHttpRequest();
        if (nid) {
            request.open('GET', `/content-hub-json/stories/${nid}/data.json`, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    let button = document.querySelector('.js-transcript');
                    button.style.display = 'inline-block';

                    let transcript = document.querySelector('.story__body');
                    transcript.style.display = 'inline-block';

                    let nodeData = JSON.parse(this.responseText);
                    if( nodeData && nodeData.content_type ) {
                        ele.querySelectorAll('.js-story-type').forEach(me => { me.classList.remove('active') });
                        ele.querySelectorAll('.js-story-type.' + nodeData.content_type).forEach(me => {
                            me.classList.add('active')
                        });
                        ele.querySelectorAll('[data-field]').forEach(me => {
                            if( nodeData[me.dataset.field] ) {
                                if( me.dataset.attr ) {
                                    me.setAttribute( me.dataset.attr, nodeData[me.dataset.field] );
                                }
                                else {
                                    me.innerHTML = nodeData[me.dataset.field];
                                }
                            }
                            if (me.dataset.field === 'field_transcript' && nodeData[me.dataset.field] === undefined) {
                                button.style.display = 'none';
                                transcript.style.display = 'none';
                            }
                        });
                        return;
                    }
                }

                if( fallbackUrl ) {
                    document.location = fallbackUrl;
                } else {
                    closeModal();
                    stopPlayingVideo();
                }
            };
            request.onerror = function () {
                // There was a connection error of some sort
                if( fallbackUrl ) {
                    document.location = fallbackUrl;
                } else {
                    closeModal();
                    stopPlayingVideo();
                }
            };
            request.send();
        }
    }
     */

    /**
     * Each story should be configured with a modal element that has a class structure like
     * <div class="js-story-type video-story"> and within that has fields that can be written
     * such as <div data-field="body"></div> or <img data-field="field-thumb" data-attr="src">
     * @param ele
     * @param nid
     *
     * @param fallbackUrl
     */
    function loadModalContent(ele, nid, fallbackUrl) {
        var userAgent = window.navigator.userAgent;
        var iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
        var webkit = !!userAgent.match(/WebKit/i);

        if (iOS && webkit && !userAgent.match(/CriOS/i)) {
            let closeX = document.querySelector('.close-modal');
            closeX.style.marginTop = '40px';
        }

        ele.querySelectorAll('[data-field]').forEach(me => {
            if( me.dataset.attr ) {
                me.setAttribute( me.dataset.attr, '' );
            }
            else {
                me.innerHTML = '';
            }
        });

        let storyButtons = ele.querySelectorAll('.js-return-to-stories');
        storyButtons.forEach(btn => {
            btn.style.display = 'none';
        });

        transcriptTexts.forEach(transcript => {
            transcript.classList.remove('show');
        });

        if (nid) {
            let request = new XMLHttpRequest();
            request.open('GET', `/content-hub-json/stories/${nid}/data.json`, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    let button = document.querySelector('.js-transcript');
                    if (button) {
                        button.style.display = 'inline-block';
                    }

                    let audioButton = document.querySelector('.js-audio-transcript');
                    if (audioButton) {
                        audioButton.style.display = 'inline-block';
                    }

                    let transcript = document.querySelector('.story__body');
                    if (transcript) {
                        transcript.style.display = 'inline-block';
                    }

                    let audiStoryBody = document.querySelector('.js-audio-story-body');
                    if (audiStoryBody) {
                        audiStoryBody.style.display = 'block';
                    }

                    let writtenStoryBody = document.querySelector('.js-written-story-body');
                    if (writtenStoryBody) {
                        writtenStoryBody.style.display = 'block';
                    }

                    let audioThumb = document.querySelector('.js-audio-thumbnail');
                    if (audioThumb) {
                        audioThumb.style.display = 'block';
                    }

                    let writtenThumb = document.querySelector('.js-written-story-thumbnail');
                    if (writtenThumb) {
                        writtenThumb.style.display = 'block';
                    }

                    let nodeData = JSON.parse(this.responseText);
                    if( nodeData && nodeData.content_type ) {
                        ele.querySelectorAll('.js-story-type').forEach(me => { me.classList.remove('active') });
                        ele.querySelectorAll('.js-story-type.' + nodeData.content_type).forEach(me => { me.classList.add('active') });
                        ele.querySelectorAll('[data-field]').forEach(me => {
                            if( me.dataset.field ) {
                                if( me.dataset.attr && nodeData[me.dataset.field] ) {
                                    me.setAttribute( me.dataset.attr, nodeData[me.dataset.field] );
                                }
                                else {
                                    me.innerHTML = nodeData[me.dataset.field];
                                }
                                if (me.dataset.field === 'field_transcript' && nodeData[me.dataset.field] === undefined) {
                                    button.style.display = 'none';
                                    transcript.style.display = 'none';
                                    audioButton.style.display = 'none';
                                }
                                if (me.dataset.field === 'body' && nodeData[me.dataset.field] === undefined) {
                                    writtenStoryBody.style.display = 'none';
                                    audiStoryBody.style.display = 'none';
                                }
                                if (me.dataset.field === 'field_audio_thumbnail' && nodeData[me.dataset.field] === undefined) {
                                    audioThumb.style.display = 'none';
                                }
                                if (me.dataset.field === 'field_textstory_thumbnail' && nodeData[me.dataset.field] === undefined) {
                                    writtenThumb.style.display = 'none';
                                }
                            }
                        });

                        storyButtons.forEach(btn => {
                            btn.style.display = 'inline-block';
                        });

                        return;
                    }
                }

                if( fallbackUrl ) {
                    document.location = fallbackUrl;
                } else {
                    closeModal();
                    stopPlayingVideo();
                }
            };
            request.onerror = function () {
                // There was a connection error of some sort
                if( fallbackUrl ) {
                    document.location = fallbackUrl;
                } else {
                    closeModal();
                    stopPlayingVideo();
                }
            };
            request.send();
        }
    }

    /**
     * This handles all events necessary when a user closes a modal.
     */
    function closeModal() {
        let selector = document.querySelector(".modal.is-visible");
        if (selector) {
            selector.classList.remove(isVisible);
        }

        document.body.classList.remove('modal-open');
        stopPlayingVideo();
    }

    /**
     * This stops the video from playing by resetting its src attribute.
     */
    function stopPlayingVideo() {
        let iframe = document.querySelector(".video-embed-field-provider-youtube iframe");
        if (iframe) {
            let videoSrc = iframe.src.split(/[?#]/)[0];
            iframe.src = videoSrc + '?autoplay=0';
        }
    }

    for (let el of openEls) {
        el.addEventListener("click", function (event) {
            event.stopPropagation();
            event.preventDefault();
            let modalId = this.dataset.open;
            let modalElement = document.getElementById(modalId);
            let fallbackUrl = null;
            modalElement.classList.add(isVisible);
            document.body.classList.add('modal-open');
            if (this.dataset.nid) {
                fallbackUrl = this.getAttribute('href');
                loadModalContent(modalElement, this.dataset.nid, fallbackUrl);
            }
            return false;
        });
    }

    for (let el of closeEls) {
        el.addEventListener("click", function (event) {
            let modalHTML = this.parentElement.parentElement.parentElement;
            modalHTML.classList.remove(isVisible);
            document.body.classList.remove('modal-open');
            event.stopPropagation();
            event.preventDefault();
            stopPlayingVideo();
            return false;
        });
    }

    for (let el of returnToStoriesButtons) {
        el.addEventListener("click", function(event) {
            let modalHTML;
            if (this.classList.contains('video-story')) {
                modalHTML = this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
            } else {
                modalHTML = this.parentElement.parentElement.parentElement.parentElement.parentElement;
            }
            modalHTML.classList.remove(isVisible);
            document.body.classList.remove('modal-open');

            let videoTranscript = document.getElementById('videotranscript');
            videoTranscript.classList.remove('show');

            event.stopPropagation();
            event.preventDefault();
            closeModal();
            stopPlayingVideo();
            return false;
        });
    }

    document.addEventListener("click", function (e) {
        var parent = document.querySelector(".modal.is-visible");
        var child = e.target;
        if (parent && parent.contains(child) && child.dataset.target !== '#videotranscript' && child.dataset.target !== '#audiotranscript') {
            closeModal();
            stopPlayingVideo();
        }
    });

    document.addEventListener("keyup", function (e) {
        // if we press the ESC
        if (e.key == "Escape" && document.querySelector(".modal.is-visible")) {
            closeModal();
            stopPlayingVideo();
        }
    });
}());


/**
 * Masonry Support
 */
(function () {
    // From https://css-tricks.com/a-lightweight-masonry-solution/
    let grids = [...document.querySelectorAll('.masonry-layout')];

    if (grids.length && getComputedStyle(grids[0]).gridTemplateRows !== 'masonry') {
        grids = grids.map(grid => ({
            _el: grid,
            gap: parseFloat(getComputedStyle(grid).gridRowGap),
            items: [...grid.childNodes].filter(c => c.nodeType === 1),
            ncol: 0
        }));

        function layout() {
            grids.forEach(grid => {
                /* get the post relayout number of columns */
                let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;

                /* if the number of columns has changed */
                if (grid.ncol !== ncol) {
                    /* update number of columns */
                    grid.ncol = ncol;

                    /* revert to initial positioning, no margin */
                    grid.items.forEach(c => c.style.removeProperty('margin-top'));

                    /* if we have more than one column */
                    if (grid.ncol > 1) {
                        grid.items.slice(ncol).forEach((c, i) => {
                            let prev_fin = grid.items[i].getBoundingClientRect().bottom /* bottom edge of item above */,
                                curr_ini = c.getBoundingClientRect().top /* top edge of current item */;

                            c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
                        })
                    }
                }
            })
        }

        addEventListener('load', e => {
            layout(); /* initial load */
            addEventListener('resize', layout, false) /* on resize */
        }, false);
    }
}());
